module.exports = __webpack_public_path__ + "img/hotdog-top-image-001sp.e28b0572.jpg";